
import { repository } from 'src/jtech/jtech-repository'

export const ServiceRequestRepository = {

  nmInterfaceCreate: 'serviceRequest.create',
  nmInterfaceFinish: 'serviceRequest.finish',
  nmInterfaceModel: 'serviceRequest.serviceRequest',
  nmInterfaceList: 'serviceRequest.list',
  nmInterfaceLoadNotFinish: 'serviceRequest.loadNotFinish',
  nmInterfaceStart: 'serviceRequest.start',
  nmInterfaceSearchClient: 'serviceRequest.searchClient',
  nmInterfaceSearchMenu: 'serviceRequest.menu',
  nmInterfaceInfoCard: 'serviceRequest.infoCard',
  nmInterfaceHistory: 'serviceRequestHistory.pesquisarHistory',

  start: async function () {
    const dados = await repository.resolve(this.nmInterfaceStart, {})
    return dados
  },

  create: async function (serviceRequest) {
    return await repository.resolveLogic(this.nmInterfaceCreate, serviceRequest)
  },

  finish: async function (serviceRequest) {
    return await repository.resolveLogic(this.nmInterfaceFinish, serviceRequest)
  },

  loadNotFinish: async function () {
    const { relacionamentos } = await repository.resolveModel(
      this.nmInterfaceLoadNotFinish,
      {
      }
    )
    return relacionamentos
  },

  loadHistoryForm: async function () {
    return await repository.resolveDatatable(this.nmInterfaceHistory)
  },

  loadHistoryData: async function (clientDocument) {
    return await repository.resolveDatatableModel(this.nmInterfaceHistory, { clientDocument: clientDocument })
  },

  model: async function ({ id }) {
    const { dadosForm } = await repository.resolveModel(
      this.nmInterfaceModel,
      {
        id: id
      }
    )
    return dadosForm
  },

  modelForm: async function (props) {
    return await repository.resolveForm(
      this.nmInterfaceModel,
      {
        id: props.id
      }
    )
  },

  list: async function (props) {
    const { relacionamentos } = await repository.resolveModel(
      this.nmInterfaceList,
      {
        ...props,
        id: props.id
      }
    )
    return relacionamentos
  },

  listForm: async function ({ id }) {
    return await repository.resolveForm(
      this.nmInterfaceList,
      {
        id: id
      }
    )
  },

  searchClient: async function ({ document }) {
    return await repository.resolveLogic(
      this.nmInterfaceSearchClient,
      {
        document: document
      }
    )
  },

  getMenu: async function () {
    const { menu } = await repository.resolveLogic(this.nmInterfaceSearchMenu, {})
    return menu
  },

  getInfoCard: async function ({ id }) {
    const form = await repository.resolveForm(this.nmInterfaceInfoCard, { id })
    const model = await repository.resolveModel(this.nmInterfaceInfoCard, { id })
    return { form, model }
  }

}
